import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ChoiceBody;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioInput, RadioInputGroup } from '@instructure/ui-radio-input';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { RichContentRenderer } from '@instructure/quiz-rce';
import { Text } from '@instructure/ui-text';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/es/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';
var ChoiceBody = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ChoiceBody = /*#__PURE__*/function (_Component) {
  function ChoiceBody() {
    _classCallCheck(this, ChoiceBody);
    return _callSuper(this, ChoiceBody, arguments);
  }
  _inherits(ChoiceBody, _Component);
  return _createClass(ChoiceBody, [{
    key: "renderDescription",
    value: function renderDescription() {
      if (this.props.screenreaderOnlyDescription) {
        return jsx(ScreenReaderContent, null, jsx(RichContentRenderer, {
          content: this.props.itemBody
        }));
      }
      return jsx(RichContentRenderer, {
        content: this.props.itemBody,
        customStyles: this.props.styles.itemBody
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(RadioInputGroup, {
        description: this.renderDescription(),
        value: this.props.selectedValue,
        name: this.props.name,
        onChange: this.props.onSelectionUpdate,
        readOnly: this.props.readOnly
      }, jsx(RadioInput, {
        "aria-label": t('Answer: {choice}', {
          choice: this.props.trueChoiceLabel
        }),
        value: "trueChoice",
        inline: true,
        label: jsx("span", {
          css: this.props.styles.userInput
        }, jsx(Text, {
          fontStyle: "normal"
        }, this.props.trueChoiceLabel))
      }), jsx(RadioInput, {
        "aria-label": t('Answer: {choice}', {
          choice: this.props.falseChoiceLabel
        }),
        value: "falseChoice",
        inline: true,
        label: jsx("span", {
          css: this.props.styles.userInput
        }, jsx(Text, {
          fontStyle: "normal"
        }, this.props.falseChoiceLabel))
      }));
    }
  }]);
}(Component), _defineProperty(_ChoiceBody, "displayName", 'ChoiceBody'), _defineProperty(_ChoiceBody, "componentId", "Quizzes".concat(_ChoiceBody.displayName)), _defineProperty(_ChoiceBody, "propTypes", {
  selectedValue: PropTypes.string,
  falseChoiceLabel: PropTypes.string,
  name: PropTypes.string.isRequired,
  onSelectionUpdate: PropTypes.func,
  trueChoiceLabel: PropTypes.string,
  itemBody: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  screenreaderOnlyDescription: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_ChoiceBody, "defaultProps", {
  selectedValue: void 0,
  onSelectionUpdate: Function.prototype,
  falseChoiceLabel: t('False'),
  trueChoiceLabel: t('True'),
  readOnly: false,
  screenreaderOnlyDescription: false
}), _ChoiceBody)) || _class);
export { ChoiceBody as default };